import React from 'react'
import { useConnect } from 'sb-redux-hook'
import { getUserFullName, links } from 'common/helpers'

import Row from 'components/_new/layout/Row/Row'
import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'

import messages from './messages'


const PersonalInfo = ({ closeMenu }) => {
  const { fullName } = useConnect({
    fullName: (state) => getUserFullName(state),
  })

  return (
    <Box pt="12" pb="12" pl="16">
      <Row>
        <Text message={fullName} size="22-32" semibold />
        <Button
          title={messages.info}
          to={links.profile.ordersStatus}
          size="sm"
          color="brandTransparent"
          onClick={closeMenu}
        />
      </Row>
    </Box>
  )
}


export default PersonalInfo
